import React from 'react';
export default function CharShow({ pageContent, flat}) {
    return (
        <div className={`side data ${flat ? 'flat' : ''}`} id='main-content'>
            {pageContent}
        </div>
    )
}